<template>
  <popper
    ref="popper"
    :trigger="trigger"
    :visible-arrow="arrowVisible"
    :disabled="disabled"
    :delay-on-mouse-over="mouseOverDelay"
    :delay-on-mouse-out="mouseOutDelay"
    :options="{
      placement,
      modifiers: modifiersFinal
    }"
    enter-active-class="scaleY-animate-enter-active"
    leave-active-class="scaleY-animate-leave-active"
    transition="scaleY-animate"
    @show="handleShow"
    @hide="handleHide"
    :boundaries-selector="boundariesSelector"
    :appendToBody="appendToBody"
  >
    <div
      class="sj-dropdown"
      :class="[dropdownClass, { customStyle }]"
      :style="[
        {
          zIndex
        },
        noMargin ? { margin: 0 } : {}
      ]"
      @click="handleDropdownClick"
    >
      <slot name="dropdown">Popper Content</slot>
    </div>
    <!--
      reverse order could cause popper created on a empty text node that cause error
    -->
    <!--<span slot="reference">-->
    <slot name="reference" slot="reference">Reference Element</slot>
    <!--</span>-->
  </popper>
</template>

<script>
/**
 * dropdown依赖popper.js实现
 * 封装于vue-popper
 */
import popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import merge from "lodash.merge";
import PopupManager from "../../../utils/popup/popupManager.js";

export default {
  name: "SjDropdown",
  components: {
    popper
  },
  data() {
    return {
      initFlag: false,
      zIndex: 2000
    };
  },
  props: {
    modifiers: {
      type: Object,
      default() {
        return {};
      }
    },
    trigger: {
      type: String,
      default: "hover",
      validator(value) {
        return ["click", "hover"].indexOf(value) !== -1;
      }
    },
    placement: {
      type: String,
      required: true
      // validator(value){
      //   return ['top', 'bottom'].indexOf(value) !== -1
      // }
    },
    mouseOutDelay: {
      type: Number,
      default: 100
    },
    mouseOverDelay: {
      type: Number,
      default: 10
    },
    disabled: {
      type: Boolean,
      default: false
    },
    closeOnClick: {
      type: Boolean,
      default: true
    },
    arrowVisible: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    dropdownClass: {
      type: String
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    arrow: Object,
    boundariesSelector: {
      type: String
    },
    customStyle: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    /**
     * 生成最终的popperjs配置项
     */
    modifiersFinal() {
      return merge(
        {
          /**
           * 不使用translate方法，而是基于绝对定位调整top与left
           */
          computeStyle: {
            gpuAcceleration: false
          },
          keepTogether: {
            enabled: true
          },
          arrow: this.arrow
        },
        this.modifiers
      );
    }
  },
  methods: {
    handleShow() {
      if (!this.disabled) {
        if (!this.initFlag) {
          this.zIndex = PopupManager.nextZIndex();
          this.initFlag = true;
        }
        this.$emit("show");
      }
    },
    handleHide() {
      if (!this.disabled) {
        this.$emit("hide");
      }
    },

    handleDropdownClick() {
      if (this.closeOnClick) {
        this.doClose();
      }
    },
    /**
     * 供使用组件处调用的控制dropdown的方法
     */
    doToggle() {
      this.$refs.popper?.doToggle();
    },
    doShow() {
      this.$refs.popper?.doShow();
    },
    doClose() {
      this.$refs.popper?.doClose();
    }
  }
};
</script>

<style lang="less">
@--dropdown-background-color: @color-antibg;
@--dropdown-border-color: @color-normal;
@--dropdown-font-color: @color-subinfo;
@--dropdown-arrow-size: 6px;

.scaleY-animate-enter-active > .sj-dropdown,
.scaleY-animate-leave-active > .sj-dropdown {
  transform: scaleY(1) !important;
}

.scaleY-animate-enter,
.scaleY-animate-leave-to {
  transition: transform 0.15s;
}

.scaleY-animate-enter > .sj-dropdown,
.scaleY-animate-leave-to > .sj-dropdown {
  transform: scaleY(0) !important;
}

.sj-dropdown {
  transition: transform 0.15s;
  transform: scaleY(1);
  transform-origin: center top 0;
  position: absolute;
  &:not(.customStyle) {
    width: auto;
    background-color: @--dropdown-background-color;
    color: @--dropdown-font-color;
    text-align: center;
    display: inline-block;
    border-radius: @base-border-radius;
    box-sizing: border-box;
    border: 1px @--dropdown-border-color solid;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    font-size: 14px;
    font-weight: normal;
  }
}

.sj-dropdown {
  & > .popper__arrow {
    border-width: @--dropdown-arrow-size;
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.1));
  }

  & > .popper__arrow::after {
    content: " ";
    border-width: @--dropdown-arrow-size;
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }
}

.sj-dropdown[x-placement^="top"] {
  transform-origin: center bottom 0;
  margin-bottom: 10px;
}

.sj-dropdown[x-placement^="top"] {
  & > .popper__arrow {
    bottom: calc(@--dropdown-arrow-size * -1);
    left: 50%;
    margin-right: calc(@--dropdown-arrow-size * 0.5);
    border-bottom-width: 0;
    border-top-color: @--dropdown-border-color;
  }
  & > .popper__arrow::after {
    bottom: 1px;
    margin-left: calc(@--dropdown-arrow-size * -1);
    border-bottom-width: 0;
    border-top-color: @--dropdown-background-color;
  }
}

.sj-dropdown[x-placement^="bottom"] {
  margin-top: 10px;
  transform-origin: center top 0;
}

.sj-dropdown[x-placement^="bottom"] {
  & > .popper__arrow {
    top: calc(@--dropdown-arrow-size * -1);
    margin-right: calc(@--dropdown-arrow-size * 0.5);
    border-top-width: 0;
    border-bottom-color: @--dropdown-border-color;
  }

  & > .popper__arrow::after {
    top: 1px;
    margin-left: calc(@--dropdown-arrow-size * -1);
    border-top-width: 0;
    border-bottom-color: @--dropdown-background-color;
  }
}

.sj-dropdown[x-placement^="right"] {
  margin-left: 12px;
}

.sj-dropdown[x-placement^="right"] {
  & > .popper__arrow {
    left: calc(@--dropdown-arrow-size * -1);
    top: 50%;
    margin-top: calc(@--dropdown-arrow-size * 0.5);
    border-left-width: 0;
    border-right-color: @--dropdown-border-color;
  }

  & > .popper__arrow::after {
    left: 1px;
    margin-top: calc(@--dropdown-arrow-size * -1);
    border-left-width: 0;
    border-right-color: @--dropdown-background-color;
  }
}

.sj-dropdown[x-placement^="left"] {
  margin-right: 10px;
}

.sj-dropdown[x-placement^="left"] {
  & > .popper__arrow {
    right: calc(@--dropdown-arrow-size * -1);
    top: 50%;
    margin-top: calc(@--dropdown-arrow-size * 0.5);
    border-right-width: 0;
    border-left-color: @--dropdown-border-color;
  }

  & > .popper__arrow::after {
    right: 1px;
    margin-top: calc(@--dropdown-arrow-size * -1);
    border-right-width: 0;
    border-left-color: @--dropdown-background-color;
  }
}
</style>
<style scoped></style>
